import { Box, Tab, Tabs } from "@mui/material";
import { withStyles } from "@mui/styles";
import { useState } from "react";
import { injectIntl } from "react-intl";
import { Styles } from "src/styles/material-styles";
import SuggestionConfiguration from "../suggestion-configuration";
import ChatbotConfiguration from "../chatbot-configuration";

// Item 09 (16/10/2026) — aba "Configuração de módulos" do CRUD de LLM (OpenAI e Gemini):
// sub-abas "Configuração de sugestão" (componente existente, intacto) e "Configuração de chatbot" (copiloto de IA no JOINT).
const ModulesConfiguration = (props) => {
    const { intl, llm, onShowNotification, onLoading, classes } = props;

    const [subTab, setSubTab] = useState(0);

    return (
        <div>
            <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 2 }}>
                <Tabs
                    value={subTab}
                    onChange={(event, newValue) => setSubTab(newValue)}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab label={intl.formatMessage({ id: "llm.modules.settings.suggestion.tab" })} />
                    <Tab label={intl.formatMessage({ id: "llm.modules.settings.chatbot.tab" })} />
                </Tabs>
            </Box>

            {subTab === 0 && (
                <SuggestionConfiguration
                    llm={llm}
                    onShowNotification={onShowNotification}
                    onLoading={onLoading}
                    classes={classes}
                />
            )}

            {subTab === 1 && (
                <ChatbotConfiguration
                    llm={llm}
                    onShowNotification={onShowNotification}
                    onLoading={onLoading}
                    classes={classes}
                />
            )}
        </div>
    );
};

export default injectIntl(withStyles(Styles)(ModulesConfiguration));
